import * as React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { GlobalStateShared, dynamicTitles, dynamicTitlesKey } from 'src/api';
import MESSAGES from './Logo.messages';
import { formatMessage } from 'src/api';

import logo from '../../../../assets/images/logo-tagged.svg';
import home from '../../../../assets/images/home.svg';

export interface LogoCenteredProps {
  authenticator?: GlobalStateShared['authenticator'];
  dispatch?: any;
  withHome?: boolean;
}

export class LogoCenteredPartial extends React.Component<LogoCenteredProps> {
  constructor(props: LogoCenteredProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  public render() {
    const { authenticator, withHome } = this.props;

    return (
      <div className="logo logo-centered d-block mx-auto mb-5">
        <Link 
          onClick={() => this.handleClick()}
          title={authenticator && authenticator.isAuthentificated ? formatMessage({...MESSAGES.logoTitleDefault}) : formatMessage({...MESSAGES.logoTitleFallback})}
          to="/"
        >
          {withHome !== false && (
            <img 
              className="logo__home img-fluid" 
              src={home}
              alt="home"
            />
          )}
          <img 
            className="logo__franke img-fluid" 
            src={logo}
            alt="logo"
          />
        </Link>
      </div>
    );
  }

  private handleClick() {
    const { authenticator } = this.props;
    this.props.dispatch(dynamicTitles.add({
      key: dynamicTitlesKey.dashboard,
      value: authenticator && authenticator.isAuthentificated ? 'Configuration Overview' : 'KWC 3D Configurator',
    }));
  }
}

export const LogoCentered = connect((state: GlobalStateShared) => ({
  authenticator: state.authenticator
}))(LogoCenteredPartial);

export default LogoCentered;